import { sql } from "drizzle-orm";

import type { DeviceRegistration } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { deviceRegistration } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";

function transformWsDeviceRegistration(r: DeviceRegistration) {
  return {
    id: r.id,
    createdAt: r.createdAt,
    updatedAt: r.updatedAt,
    surface: r.surface,
    deviceOsName: r.deviceOsName,
    deviceOsVersion: r.deviceOsVersion,
    deviceModel: r.deviceModel,
    friendlyName: r.friendlyName,
    drivingDetectionEnabled: r.drivingDetectionEnabled ?? true,
    wakeWordSensitivity: String((r as unknown as { wakeWordSensitivity?: number }).wakeWordSensitivity ?? "0.3"),
    commandSensitivity: String((r as unknown as { commandSensitivity?: number }).commandSensitivity ?? "0.2"),
    silenceDetectionInitialThreshold: String(
      (r as unknown as { silenceDetectionInitialThreshold?: number }).silenceDetectionInitialThreshold ?? "0.25",
    ),
    silenceDetectionFinalThreshold: String(
      (r as unknown as { silenceDetectionFinalThreshold?: number }).silenceDetectionFinalThreshold ?? "0.5",
    ),
    commandTimingWindowMs: r.commandTimingWindowMs ?? 2500,
    recordingTimeoutWindowMs: r.recordingTimeoutWindowMs ?? 3000,
  };
}

export async function bulkUpsertDeviceRegistration(records: DeviceRegistration[]) {
  if (records.length === 0) return;
  const data = records.map((r) => transformWsDeviceRegistration(r));
  const deduped = deduplicateByKeyValue(data, (item) => item.id);
  await bulkInsert(deviceRegistration, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [deviceRegistration.id],
      set: {
        createdAt: sql`excluded."createdAt"`,
        updatedAt: sql`excluded."updatedAt"`,
        surface: sql`excluded."surface"`,
        deviceOsName: sql`excluded."deviceOsName"`,
        deviceOsVersion: sql`excluded."deviceOsVersion"`,
        deviceModel: sql`excluded."deviceModel"`,
        friendlyName: sql`excluded."friendlyName"`,
        drivingDetectionEnabled: sql`excluded."drivingDetectionEnabled"`,
        wakeWordSensitivity: sql`excluded."wakeWordSensitivity"`,
        commandSensitivity: sql`excluded."commandSensitivity"`,
        silenceDetectionInitialThreshold: sql`excluded."silenceDetectionInitialThreshold"`,
        silenceDetectionFinalThreshold: sql`excluded."silenceDetectionFinalThreshold"`,
        commandTimingWindowMs: sql`excluded."commandTimingWindowMs"`,
        recordingTimeoutWindowMs: sql`excluded."recordingTimeoutWindowMs"`,
      },
    },
  });
  emitTableUpdates(["device_registration"]);
}
